import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
@Injectable()
export class ScrollimationService {

    constructor(
        private isReady$: Observable<boolean>,
    ) { }

    isReady() {
        return this.isReady$;
    }
}
